
export const environment = {
  firebase: {
    projectId: 'mysafebackapp',
    appId: '1:113635900805:web:6eff2d036a1e4084b598ec',
    storageBucket: 'mysafebackapp.appspot.com',
    apiKey: 'AIzaSyBHI3LF7sGIDVB7XjrodL6ZdEKEKHpoM6g',
    authDomain: 'mysafebackapp.firebaseapp.com',
    messagingSenderId: '113635900805',
    measurementId: 'G-K7X8GVMGNE',
  },
  production: true,
  bundle: 'im.fabricio.msbapp',
  API_URL: 'http://192.168.18.4:3333/api',
  week_inicial_id: 1,
  week_final_id: 10,
};